import { Node_Type } from "./../ricos-types/index.js";
const DIVIDER_SIZE_RESOLVER_ID = "GET_DIVIDER_NODE_SIZE";
const DIVIDER_STYLE_RESOLVER_ID = "GET_DIVIDER_NODE_STYLE";
const DIVIDER_BUTTONS = {
  size: `${Node_Type.DIVIDER}.size`,
  style: `${Node_Type.DIVIDER}.style`,
  alignment: `${Node_Type.DIVIDER}.alignment`
};
export {
  DIVIDER_BUTTONS,
  DIVIDER_SIZE_RESOLVER_ID,
  DIVIDER_STYLE_RESOLVER_ID
};
//# sourceMappingURL=const.js.map
